module.exports = __webpack_public_path__ + "img/kilcannon.86d25697.jpg";